import React from "react";
import { WarningCircle } from "@phosphor-icons/react";
import { ruleProblems } from "@/lib/ruleCheck";

export const RuleCheck = ({ criteria }) => {
  const items = ruleProblems(criteria);
  if (!items.length) return null;
  const hard = items.filter((i) => !i.soft).length;
  return (
    <div className={`border-2 p-4 ${hard ? "border-red-700 bg-red-50" : "border-amber-600 bg-amber-50"}`} data-testid="rule-check">
      <div className="flex items-center gap-2 font-chivo font-black uppercase tracking-tight text-sm mb-1">
        <WarningCircle size={18} weight="bold" />
        {hard ? "These rules turn away leads from their pages" : "Check this rule"}
      </div>
      <p className="text-[11px] text-zinc-700 mb-2">
        A lead that fails any rule isn&apos;t sent to this buyer, and the visitor sees the general thank-you page instead of theirs.
        Fix the rules below, then press Save changes.
      </p>
      <ul className="list-disc pl-5 space-y-1 text-xs">
        {items.map((i) => <li key={i.key} data-testid={`rule-check-${i.key}`}>{i.text}</li>)}
      </ul>
    </div>
  );
};
